export function getClientId(): string {
  const googleAnalytics = window.ga;
  if (!googleAnalytics || !googleAnalytics.getAll) {
    throw new GaNotAvailable();
  }

  const all = googleAnalytics.getAll();
  if (!all || all.length !== 1) {
    throw new GaGetAllInvalidReturn(all);
  }

  const clientId = all[0].get('clientId');
  if (!clientId) {
    throw new GaClientIdNotDefined();
  }

  return clientId;
}

export class GaError extends Error {
}

export class GaNotAvailable extends GaError {
  constructor() {
    super('Google Analytics (window.ga) not avaiable');
  }
}

export class GaGetAllInvalidReturn extends GaError {
  constructor(data: unknown) {
    super('window.ga.getAll() returned invalid data: ' + data);
  }
}

export class GaClientIdNotDefined extends GaError {
  constructor() {
    super('window.ga.clientId is not defined');
  }
}
